<template>
    <div id="decision">
        <Banner title="醫病共同決策專區" :breadcrumbs="breadcrumbs" type="decision"></Banner>
        <div class="container">
            <div class="center_title">
                <Title en="Medical decision" chtFirst="醫病" chtSecond="共同決策" :center="true"></Title>
            </div>
            <section class="list_box">
                <div
                    class="list"
                    v-infinite-scroll="loadMore"
                    infinite-scroll-disabled="busy"
                    infinite-scroll-distance="10"
                    v-show="MedicalDecisions.length > 0"
                >
                    <div class="item" v-for="(item,index) in MedicalDecisions" :key="index">
                        <div class="image">
                            <img :src="item.Image || require('@/assets/default-big.png')" />
                        </div>
                        <div class="title">{{item.Title}}</div>
                        <div class="btn_box">
                            <div class="Orange_btn islogin">
                                <a :href="item.GoogleForm" target="_blank">了解詳情</a>
                            </div>
                        </div>
                    </div>
                </div>
                <notfound v-if="MedicalDecisions.length == 0" info="目前尚未填寫醫病回饋，"></notfound>
            </section>
        </div>
        <loading v-if="isLoading"></loading>
    </div>
</template>

<script>
import API from "@/service/medical.js";
export default {
    name: "decision",
    components: {},
    props: ["propdata"],
    data() {
        return {
            breadcrumbs: [
                {
                    url: "/",
                    title: "首頁"
                },
                {
                    title: "醫病共同決策專區"
                },
                {
                    url: "/MedicalDecision/Index",
                    title: "醫病共同決策"
                }
            ],
            MedicalDecisions: [],
            Totalpage: 1,
            Page: 1,
            Count: 10,
            busy: false,
            isLoading: false
        };
    },
    methods: {
        loadMore() {
            const vm = this;
            vm.busy = true;
            if (vm.Totalpage == 1 || vm.Totalpage == vm.Page) {
                return false;
            }
            vm.isLoading = true;
            vm.Page += 1;
            API.getMedicalDecisionList({ leaf: vm.Page, count: 10 }).then(
                result => {
                    if (result.Data.Questionnaires.length === 0) {
                        return false;
                    } else {
                        setTimeout(function() {
                            vm.busy = false;
                        }, 1000);
                    }
                    setTimeout(function() {
                        vm.isLoading = false;
                    }, 500);
                    let QuestionnaireList = result.Data.Questionnaires;
                    vm.MedicalDecisions = vm.MedicalDecisions.concat(
                        QuestionnaireList
                    );
                }
            );
        }
    },
    computed: {},
    created() {
        const vm = this;
        if (vm.propdata) {
            let obj = JSON.parse(vm.propdata);
            vm.MedicalDecisions = obj.Questionnaires;
            vm.Totalpage = Math.ceil(parseInt(obj.Total) / vm.Count);
        } else {
            vm.MedicalDecisions = [
                {
                    Id: "5f68da0d-59b1-4517-95f9-95c8c27d98c5",
                    Title: "健康新知2017 - 糖尿病視網膜病變上",
                    Image:
                        "https://retinasociety.blob.core.windows.net/medical-decision/5f68da0d-59b1-4517-95f9-95c8c27d98c5/e420f096f84a4a7eb0f1a8c98b46bf30.jpg",
                    GoogleForm: "https://forms.gle/gPV2pv9UFbaF76CQ6"
                },
                {
                    Id: "85d10b86-a0d8-4586-861d-69359f39b37c",
                    Title: "2019視網膜最新問答題",
                    Image:
                        "https://retinasociety.blob.core.windows.net/medical-decision/85d10b86-a0d8-4586-861d-69359f39b37c/ec9dee8ba48a44d9ad0ab6be24db3393.jpg",
                    GoogleForm:
                        "https://docs.google.com/forms/d/e/1FAIpQLSegwdfuQAN7Py2HX1orHofrz5zhRBpKOPM0VjRiUC3_dpKVSg/viewform"
                }
            ];
        }
    },
    mounted() {},
    watch: {}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#decision .list_box {
    margin-bottom: 60px;
}
#decision .list {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    margin-bottom: 60px;
}
#decision .list::after {
    content: "";
    flex: 0 0 30%;
    width: 30%;
    max-width: 350px;
}
#decision .list .item {
    position: relative;
    width: 30%;
    max-width: 350px;
    margin-bottom: 25px;
    transition: 0.5s;
    border: 1px solid #eee;
}
#decision .list .item:hover {
    transform: translateY(-2px);
    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23);
}

#decision .list .item .image {
    font-size: 0;
    /* border: 2px solid #a59b9205; */
}
#decision .list .item .image img {
    width: 100%;
}
#decision .list .item .title {
    padding: 10px;
    letter-spacing: 2px;
    line-height: 1.5;
    min-height: 70px;
}
#decision .list .item .btn_box {
    max-width: 95%;
    margin: 30px auto;
}
@media screen and (max-width: 767px) {
    #decision .list .item {
        width: 100%;
        max-width: none;
        margin: 0 auto 30px;
        box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23);
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/decision.vue